import { Route, Routes } from "react-router-dom";
import Accountability from "./Accountability";

export default function AccountabilityRouter() {
  return (
    <Routes>
      <Route path="/" element={<Accountability />} />
    </Routes>
  );
}
